import type { KeyboardEvent } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectClientTabHasUnsavedChanges } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

const keepKeyInBadge = (event: KeyboardEvent) => event.stopPropagation()

const useUnsavedChangesBadge = () => {
  const { t } = useTranslation()
  const hasUnsavedChanges: boolean = useSelector(selectClientTabHasUnsavedChanges)

  return {
    hidden: !hasUnsavedChanges,
    label: t('subscriptionForm:client_tab.unsaved_changes_tooltip'),
    onKeyDown: keepKeyInBadge,
  }
}

export default useUnsavedChangesBadge
